import React from 'react';

export const SCHOOLS_MAIN_TEXT = (count) => <>

    В этом разделе Вы можете посмотреть школы, которые представлены на Портале.
    <br/>
    {`
     В данный момент количество зарегистрированых школ: ${count}
    `}
    <br/><br/>
    Кликнув на любую из плашек, Вы можете перейти на страницу школы, где представлены состав, градация поясов и соревновательный рейтинг. По мере
    развития портала, на страницу школы будет добавлять дополнительная информация. 
    <br/><br/>

    Каждый пользователь Портала при регистрации указывает свою школу и кордао. 
    <br/>
    Если Вашей школы нет в базе данных, Вы можете зарегистрироваться баз 
    школы, выбрав последний вариан '- - -'. 
    <br/><br/>
    При этом Вы можете подать заявку на добавление школы, подробнее по ссылке ниже:
</>

export const SCHOOLS_HOW_TO_ADD = {
    title: 'Как добавить школу на Портал?',
    value: <>
    
    Если Вы хотите, чтобы Ваша школа была представлена на Портале, Вы можете обратиться к администратору:
    <br/><br/>
    Чушев Сергей <br/>
    <a href = 'https://wa.me/79267674316?text=По+вопросу+добавления+школы+на+портал'>8 926 767 43 16</a> <br/>
    <br/>
    Вам необходимо предоставить следующую информацию: <br/>
    - Название школы (если превышает 19 символов, желательно сокращение) <br/>
    - Логотип школы, желательно в формате PNG или векторном <br/>
    - Градацию школу: названия степеней поясов и расцветку
    </>
}